import { FC, useState } from "react";
import CustomPopup from "../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../custom-hooks/useAppDispatch";
import { WorkServiceImpl } from "../../../services/WorkServiceImpl";
import AcceptCheckMarkSVG from "../../resources/svg/functional/AcceptCheckMarkSVG";

interface CompleteWorkProps {
    workId: string;
}

const CompleteWork: FC<CompleteWorkProps> = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isCompleting, setIsCompleting] = useState(false);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const completeWorkHandler = async () => {
        if (isCompleting) return;

        setIsCompleting(true);
        try {
            const result = await dispatch(WorkServiceImpl.completeWorkThunk({ id: props.workId }));
            if (result.meta.requestStatus === "fulfilled") {
                setIsVisible(false);
            }
        } finally {
            setIsCompleting(false);
        }
    };

    return (
        <CustomPopup
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            confirmHandler={completeWorkHandler}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px]"
            confirmTitle={t("common.yes")}
            cancelTitle={t("common.no")}
            confirmButtonClassName="bg-transparent hover:bg-transparent w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mr-8 dmax2:mr-6 mt-8 dmax2:mt-6"
            cancelButtonClassName="w-[65px] dmax2:w-[47px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
            buttonElement={
                <button
                    type="button"
                    onClick={() => setIsVisible(true)}
                    disabled={isCompleting}
                    className="flex justify-center items-center w-[228px] dmax2:w-[158px] h-[54px] dmax2:h-[42px] rounded-[12px] dmax2:rounded-[8px] bg-accentGreen hover:bg-accentGreenFocused disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer transition duration-300"
                >
                    <AcceptCheckMarkSVG className="mr-2.5 dmax2:mr-1 w-6 dmax2:w-5 h-6 dmax2:h-5 text-textWhite" />
                    <span className="H16 dmax2:H14 text-white dmin2:pb-[2px] dmax2:pt-[2px]">
                        {t("work.completeWork")}
                    </span>
                </button>
            }
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[340px] ti6:max-w-[340px] ti7:max-w-[280px] tmax4:max-w-[280px] break-words">
                {t("work.completionAssurance")}
            </p>
        </CustomPopup>
    );
};

export default CompleteWork;
